import { useQuery } from "@apollo/client";
import { Sidepanel, ToastContainer } from "pepsico-ds";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { loadEngagementById } from "../../graphql/queries/loadEngagementById";
import PerformanceDetailsContainer from "./PerformanceDetailsContainer";
import "./performanceDetails.scss";

const PerformanceDetailsDrawer = ({
  showDrawer,
  engagementItem,
  onCloseDrawer,
  onDetailViewClick = () => {},
  onApprove = () => {},
  onReject = () => {},
}) => {
  const [engagementData, setEngagementData] = useState(null);
  const [toastData, setToastData] = useState(null);
  const {
    data: engagementDetails,
    loading,
    error,
  } = useQuery(loadEngagementById, {
    variables: {
      id: engagementItem?.id,
    },
    skip: !engagementItem?.id,
    fetchPolicy: "network-only",
  });

  useEffect(() => {
    if (engagementDetails && !error) {
      setEngagementData(engagementDetails.loadEngagementById);
    }
    if (error) {
      setToastData([{ type: "error", text: "Error loading performance details" }]);
    }
  }, [engagementDetails, error]);
  return (
    <Sidepanel
      className={`${["FAILED", "PENDING", "REJECTED", "AUTO_REJECTED"].includes(engagementItem?.status) && !loading && !error ? "" : "hide-footer"} performance-details-drawer`}
      showSidePanel={showDrawer}
      onCloseSidePanel={onCloseDrawer}
      title="Performance details"
      type="lateral"
      anchor="right"
      verticalSidepanelHeight="100%"
      isDark={false}
      data-testid="performance-details-drawer"
      primaryButtonProps={{
        onClick: onApprove,
        size: "medium",
        text: "Approve",
        variant: "primary",
      }}
      secondaryButtonProps={{
        onClick: onReject,
        size: "medium",
        text: "Reject",
        variant: "tertiary",
      }}
      showLink={false}
      showSlot={true}
      showTertiaryButton={false}
      showSecondaryButton={
        !["REJECTED", "AUTO_REJECTED"].includes(engagementItem?.status)
      }
    >
      <div className="performance-details-drawer">
        <PerformanceDetailsContainer
          title="Details"
          showFooter={false}
          showDetailViewOption={true}
          onDetailViewClick={() => onDetailViewClick()}
          engagementData={engagementData}
          loading={loading}
        />
        {engagementItem?.status?.toLowerCase() === "pending" &&
          !error &&
          !loading && (
            <div className="performance-details-drawer-footer">
              <div className="performance-details-drawer-footer-title">
                Performance is pending
              </div>
              <div className="performance-details-drawer-footer-description">
                Do you want to approve it?
              </div>
            </div>
          )}
      </div>
      {toastData && (
        <ToastContainer
          className="performances-listing-toast"
          data={toastData}
          removeToast={() => setToastData([])}
          showActionIcon
        />
      )}
    </Sidepanel>
  );
};
PerformanceDetailsDrawer.propTypes = {
  showDrawer: PropTypes.bool.isRequired,
  engagementItem: PropTypes.shape({
    status: PropTypes.string,
    id: PropTypes.string,
  }).isRequired,
  onCloseDrawer: PropTypes.func,
  onDetailViewClick: PropTypes.func,
  onApprove: PropTypes.func,
  onReject: PropTypes.func,
};

export default PerformanceDetailsDrawer;
